'use client';
import Image from 'next/image';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import Button from '@/components/ui/button/Button';
import styles from './MerchantsFeatures.module.css';

export default function MerchantsFeatures({ selectedMarket }: { selectedMarket: 'es' | 'it' }) {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.featuresSection}>
      <div className={styles.container}>
        <h2 className={styles.heading} suppressHydrationWarning>{t('merchants.features.heading')}</h2>

        <div className={styles.contentContainer}>
          <div className={styles.content}>
            <div className={styles.featuresContainer}>
              <div className={styles.featureItem}>
                <h3 className={styles.featureTitle} suppressHydrationWarning>
                  {t('merchants.features.dataManagement.title')}
                </h3>
                <p className={styles.featureDescription} suppressHydrationWarning>
                  {t('merchants.features.dataManagement.description')}
                </p>
              </div>
              <div className={styles.featureItem}>
                <h3 className={styles.featureTitle} suppressHydrationWarning>
                  {t('merchants.features.documentReady.title')}
                </h3>
                <p className={styles.featureDescription} suppressHydrationWarning>
                  {t('merchants.features.documentReady.description')}
                </p>
              </div>
              <div className={styles.mobileImageContainer}>
                <Image
                  src="/images/merchant-platform.png"
                  alt={t('merchants.features.platformImage.alt')}
                  width={344}
                  height={178}
                  className={styles.featureImage}
                />
              </div>
            </div>

            <Button
              variant="primary"
              className={styles.ctaButton}
              href={
                selectedMarket === 'it'
                  ? 'https://signup.stampit.co/'
                  : 'https://sales.askforstamp.com/signup'
              }
              target="_blank"
              suppressHydrationWarning
            >
              {t('merchants.features.ctaText')}
            </Button>
          </div>
          <div className={styles.desktopImageContainer}>
            <Image
              src="/images/software_img_merchant_desktop.webp"
              alt={t('merchants.features.platformImage.alt')}
              width={734}
              height={380}
              className={styles.featureImage}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
